<template>
  <div>
    <Table :no-data-text="$t('common.noData')" :columns="columns1" :loading="modalLoading" :data="queryUserByGroupIdList" style="width: 100.1%;">
        <template slot-scope="{row,index}" slot="delete">
            <span @click="doDelete(index)">
                <Button type="error" size="small" @click="userDelmodal = true" v-hasPermission="['permissionsConfigurationManagement:resourcePermission:delete_user']">{{ $t('alarms.common.delete') }}</Button>
            </span>
        </template>
    </Table>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page :current="current" :total="dataTotal" show-sizer :page-size="pageSize" @on-change="changePage" @on-page-size-change="changeSize" :transfer="true"></Page>

    <Modal v-model="userDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t('alarms.common.deleteConfirmation') }}</span>
      </p>
      <div style="text-align:center">
        <p>{{ $t('alarms.common.sureDelete') }} {{Name}} {{ $t('alarms.common.what') }}?</p>
      </div>
      <div slot="footer">
        <Button type="error" size="large" long @click="deleteUser()" :disabled="isDisable">{{ $t('alarms.common.delete') }}</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
    var tableUsers = {}
    export default {
        name: 'TableUsers',
        data() {
            return {
                current:1,
                dataTotal:0,
                pageSize:10,
                Name: '',
                modalLoading: true,
                userDelmodal: false,
                isDisable: false,
                columns1: [
                    {
                        title:  this.$t('permission_configuration_management.user.userName'),
                        key: 'name'
                    },
                    {
                        title:this.$t('permission_configuration_management.account.company'),
                        key:'companyName'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.email'),
                        key: 'email'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.loginStatus'),
                        key: 'isState'
                    },
                    {
                        title: this.$t('permission_configuration_management.user.accountStatus'),
                        key: 'isActive'
                    },
                    {
                        title: this.$t('common.operation'),
                        slot: 'delete'
                    }
                ],
                queryUserByGroupIdList: [{
                    name: ''
                }]
            }
        },
        beforeCreate: function () {
            tableUsers = this
        },
        mounted: function () {
            tableUsers.queryUsersByGroupId();
        },
        methods: {
            // 点击备份目标的时候显示实例列表
            queryUsersByGroupId: function () {
                tableUsers.$api.user.selectQueryUsersByGroupId({
                    "groupId": this.$route.query.id,
                    "pageNum": this.current,
                    "pageSize": this.pageSize
                })
                .then(res => {
                    this.modalLoading = false;
                    this.queryUserByGroupIdList = res.data.records;
                    // 显示状态
                    for (var i = 0; i < this.queryUserByGroupIdList.length; i++) {
                        // 登陆状态
                        if (this.queryUserByGroupIdList[i].state === 1) {
                            this.queryUserByGroupIdList[i].isState = this.$t('permission_configuration_management.user.onLine')
                        } else if (this.queryUserByGroupIdList[i].state === 0) {
                            this.queryUserByGroupIdList[i].isState = this.$t('permission_configuration_management.user.offLine')
                        }
                        // 是否有效
                        if (this.queryUserByGroupIdList[i].active) {
                            this.queryUserByGroupIdList[i].isActive = this.$t('permission_configuration_management.user.enable')
                        } else {
                            this.queryUserByGroupIdList[i].isActive = this.$t('permission_configuration_management.user.disable')
                        }
                    }
                    // 当前页
                    this.current = res.data.current;
                    // 总条数
                    this.dataTotal = res.data.total;
                })
                .catch(res => {
                    // 如果列表里没数据 返回
                    this.modalLoading = false;
                    this.queryUserByGroupIdList = undefined
                })
            },
            changePage: function(current){
                this.current=current;
                tableUsers.queryUsersByGroupId();
            },
            changeSize: function(pageSize){
                this.pageSize=pageSize;
                tableUsers.queryUsersByGroupId();
            },
            // 显示所有数据
            showAllUser: function () {
                tableUsers.queryUsersByGroupId()
            },
            doDelete: function (index) {
                this.lineIndex = index
                this.Name = this.queryUserByGroupIdList[index].name
            },
            // 删除user
            deleteUser: function () {
                this.isDisable = true // 开始可以点击
                var lineIndex = this.lineIndex
                // 删除实例
                tableUsers.$api.groupUserRelation.deleteGroupUserRelation({
                    'groupId': this.$route.query.id,
                    'userId': this.queryUserByGroupIdList[lineIndex].id
                })
                .then(res => {
                    setTimeout(() => {
                        // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
                        //21条  3页  2*10+1时删除
                        if (lineIndex == 0 && ((this.current - 1) * this.pageSize + 1) == this.dataTotal) {
                            this.current = this.current - 1;
                        }
                        this.dataTotal = this.dataTotal - 1;
                        tableUsers.queryUsersByGroupId();
                        this.isDisable = false;
                        this.userDelmodal = false;
                        this.$Message.success('删除成功');
                    }, 1000);
                })
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/TableUsers.vue